export var tripadvisorAwardtype = function (tripadvisorAwardtype) {
  tripadvisorAwardtype["CHOICE"] = "choice";
  tripadvisorAwardtype["BEST"] = "best";
  return tripadvisorAwardtype;
}({});